const isElementFocusable = (element) => {
  function isVisible(el) {
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isInDocument(el) {
    return document.body.contains(el);
  }

  function hasFocusMethod(el) {
    return typeof el.focus === 'function';
  }

  return (
    isVisible(element) &&
    isInDocument(element) &&
    element.tabIndex >= 0 &&
    hasFocusMethod(element) &&
    (element.tagName !== 'A' || element.hasAttribute('href'))
  );
};

const elementFocus = (element) => {
  if (!isElementFocusable(element)) {
    return;
  }
  element.focus();
};

export { elementFocus };
